import { Group } from "~/types";

type Props = {
    currentIndex: number;
    currentGroupIndex: number;
    options: Group[];
};

const IndexPoints = ({ currentIndex, currentGroupIndex, options }: Props) => {
    return (
        <div className="dots">
            {options[currentGroupIndex]?.Options.length <= 10 ? (
                options[currentGroupIndex]?.Options.map((o, i) => (
                    <span key={i} className={`dot ${i === currentIndex && "active"}`} />
                ))
            ) : (
                <span className="more-than-ten">
                    {currentIndex + 1} of {options[currentGroupIndex]?.Options.length}
                </span>
            )}
        </div>
    )
}

export default IndexPoints;